import React, { FC, SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface GreenCheckCircleIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}
const GreenCheckCircleIcon: FC<GreenCheckCircleIconProps> = ({
  width = 16,
  height = 16
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check-circle">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00002 0.666626C3.94993 0.666626 0.666687 3.94987 0.666687 7.99996C0.666687 12.05 3.94993 15.3333 8.00002 15.3333C12.0501 15.3333 15.3334 12.05 15.3334 7.99996C15.3334 3.94987 12.0501 0.666626 8.00002 0.666626ZM11.4714 6.47136C11.7318 6.21101 11.7318 5.7889 11.4714 5.52855C11.2111 5.26821 10.789 5.26821 10.5286 5.52855L7.00002 9.05715L5.47142 7.52855C5.21108 7.2682 4.78896 7.2682 4.52862 7.52855C4.26827 7.7889 4.26827 8.21101 4.52862 8.47136L6.52862 10.4714C6.78896 10.7317 7.21108 10.7317 7.47143 10.4714L11.4714 6.47136Z"
          fill="#027A48"
        />
      </g>
    </svg>
  </SVGUniqueID>
);
export { GreenCheckCircleIcon };
